import { render, staticRenderFns } from "./TenderSituationModal.vue?vue&type=template&id=18c09738&scoped=true&"
import script from "./TenderSituationModal.vue?vue&type=script&lang=ts&"
export * from "./TenderSituationModal.vue?vue&type=script&lang=ts&"
import style0 from "./TenderSituationModal.vue?vue&type=style&index=0&id=18c09738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c09738",
  null
  
)

export default component.exports